import type { ComponentProps } from 'react';
import { OwcWorkflowOverlay } from '@one/react';

export type PocWorkflowOverlayProps = ComponentProps<typeof OwcWorkflowOverlay>;

export const PocWorkflowOverlay: React.FC<PocWorkflowOverlayProps> = (props) => <OwcWorkflowOverlay {...props} />;
